<template>
    <div>
        <div class="w-5/6 p-6 mb-3 border border-gray-100 shadow other-message-bubble my-rounded md:w-3/4">
            <div class="flex items-center">
                <div
                class="self-start hidden w-1/4 mr-3 bg-gray-100 border rounded-full md:block"
                :style="'background-image: url(' + avatar + ')'"
                style="
                    background-size: cover;
                    background-position: center center;
                    width: 45px;
                    height: 45px;
                "
                ></div>
                <div class="w-3/4">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            avatar: 'https://disticloudfiles.net/img/savinfo/default/avatar-chat-bot.png'
        }
    }
}
</script>

<style lang="scss" scoped>
.other-message-bubble {
    position: relative;
    background: #fff;
}
// .other-message-bubble:after {
//     content: '';
//     position: absolute;
//     display: block;
//     width: 0;
//     z-index: 1;
//     border-style: solid;
//     border-width: 0 0 20px 20px;
//     border-color: transparent transparent #fff transparent;
//     top: 72%;
//     left: -20px;
//     margin-top: -10px;
// }

</style>



// WEBPACK FOOTER //
// src/processes/cards/tchat/Components/BotMessageBubble.vue